import { z } from "zod";
import { bookingStatusSchema } from "../booking/booking-status.js";
import { cautionStatusSchema } from "../caution/caution-status.js";
import { isoDateOnlySchema } from "../common/date.js";
export const MCP_DEFAULT_LIMIT = 25;
export const MCP_MAX_LIMIT = 100;
const limitSchema = z.number().int().min(1).max(MCP_MAX_LIMIT).optional();
const searchSchema = z.string().min(1).max(200).optional();
const confirmSchema = z.boolean().optional();
export const mcpListPropertiesInputSchema = z.object({
    search: searchSchema,
});
export const mcpGetPropertyInputSchema = z.object({
    property_id: z.uuid(),
});
export const mcpCheckAvailabilityInputSchema = z.object({
    property_id: z.uuid(),
    start_date: isoDateOnlySchema,
    end_date: isoDateOnlySchema,
});
export const mcpListBookingsInputSchema = z.object({
    search: searchSchema,
    status: bookingStatusSchema.optional(),
    property_id: z.uuid().optional(),
    start_date_from: isoDateOnlySchema.optional(),
    start_date_to: isoDateOnlySchema.optional(),
    limit: limitSchema,
});
export const mcpGetBookingInputSchema = z.object({
    booking_id: z.uuid().optional(),
    reference_code: z.string().min(1).max(32).optional(),
});
export const mcpListCautionsInputSchema = z.object({
    search: searchSchema,
    status: cautionStatusSchema.optional(),
    limit: limitSchema,
});
export const mcpGetCautionInputSchema = z.object({
    caution_id: z.uuid(),
});
export const mcpListTenantsInputSchema = z.object({
    search: searchSchema,
});
export const mcpGetTenantInputSchema = z.object({
    tenant_id: z.uuid(),
});
export const mcpCreateBookingInputSchema = z.object({
    property_id: z.uuid(),
    start_date: isoDateOnlySchema,
    end_date: isoDateOnlySchema,
    num_guests: z.number().int().min(1),
    num_adults: z.number().int().min(0).optional(),
    num_children: z.number().int().min(0).optional(),
    num_infants: z.number().int().min(0).optional(),
    pet_count: z.number().int().min(0).optional(),
    includes_linens: z.boolean().optional(),
    includes_towels: z.boolean().optional(),
    security_deposit: z.number().int().min(0),
    notes: z.string().max(2000).optional(),
    tenant_email: z.email().toLowerCase().trim(),
    tenant_first_name: z.string().min(1).max(100).optional(),
    tenant_last_name: z.string().min(1).max(100).optional(),
    tenant_phone: z.string().max(30).optional(),
    tenant_address: z.string().max(500).optional(),
    confirm: confirmSchema,
});
export const mcpCreateCautionInputSchema = z.object({
    amount: z.number().int().positive(),
    note: z.string().max(2000).optional(),
    release_date: z.iso.datetime(),
    tenant_email: z.email().toLowerCase().trim(),
    tenant_first_name: z.string().min(1).max(100).optional(),
    tenant_last_name: z.string().min(1).max(100).optional(),
    tenant_phone: z.string().max(30).optional(),
    booking_id: z.uuid().optional(),
    confirm: confirmSchema,
});
export const mcpReleaseCautionInputSchema = z.object({
    caution_id: z.uuid(),
    retained_amount: z.number().int().min(0),
    release_note: z.string().max(2000).optional(),
    confirm: confirmSchema,
});
export const mcpCancelCautionInputSchema = z.object({
    caution_id: z.uuid(),
    confirm: confirmSchema,
});
export const mcpResendCautionEmailInputSchema = z.object({
    caution_id: z.uuid(),
});
export const mcpResendSignatureEmailInputSchema = z.object({
    booking_id: z.uuid(),
});
